import React, { useEffect } from "react";

const TicketinoShopPlugin = ({ language }) => {
    // Load ticketino external scripts
    useEffect(() => {
        // Load CSS
        const linkElement = document.createElement('link');
        linkElement.rel = 'stylesheet';
        linkElement.href = 'https://plugin.ticketino.com/getPluginFilesCss';
        linkElement.crossOrigin = 'anonymous';
        linkElement.id = 'ticketino-css'; // Add ID for easier cleanup
        document.head.appendChild(linkElement);

        // Load JavaScript
        const scriptElement = document.createElement('script');
        scriptElement.src = 'https://plugin.ticketino.com/getPluginFiles';
        scriptElement.type = 'text/javascript';
        scriptElement.id = 'ticketino-script'; // Add ID for easier cleanup
        document.body.appendChild(scriptElement);

        // Cleanup function to remove scripts when component unmounts
        return () => {
            if (linkElement && linkElement.parentNode) {
                linkElement.parentNode.removeChild(linkElement);
            }
            if (scriptElement && scriptElement.parentNode) {
                scriptElement.parentNode.removeChild(scriptElement);
            }
        };
    }, []);

    // Determine languageISO based on language prop
    const languageISO = language === "en" ? "en" : "de";

    return (
        <div className="ticketino-plugin-wrapper">
            <style>
                {`
                    /* Isolate Ticketino plugin styles */
                    .ticketino-plugin-wrapper {
                        isolation: isolate;
                        position: relative;
                    }

                    .ticketino-plugin-wrapper .ticketinoApp {
                        color: #000000 !important;
                        background-color: #ffffff !important;
                        font-family: inherit !important;
                    }

                    .ticketino-plugin-wrapper button {
                        color: #000000 !important;
                        background-color: #ffffff !important;
                    }

                    .ticketino-plugin-wrapper select, 
                    .ticketino-plugin-wrapper input {
                        color: #000000 !important;
                        background-color: #ffffff !important;
                    }

                    .ticketino-plugin-wrapper .ticketObjectDiv {
                        color: #000000 !important;
                        background-color: #ffffff !important;
                    }

                    .ticketino-plugin-wrapper .eventObjectDiv {
                        color: #000000 !important;
                        background-color: #ffffff !important;
                    }

                    /* Reset any potential Bootstrap interference */
                    .ticketino-plugin-wrapper * {
                        box-sizing: border-box;
                    }

                    .ticketinoSelect {
                        margin-bottom: 20px;
                    }
                `}
            </style>
            <div className="container wrapper">
                <div
                    id="ticketinoShopPlugin"
                    organizerId="958842"
                    eventId="0"
                    eventGroupId="0"
                    showAllEvents="true"
                    currency="chf"
                    languageISO={languageISO}
                    enableTickets=""
                    disableTickets=""
                    showTicketDescription="true"
                    wantedFields="firstName;name;countryId;postCode;city;salutation;street;deliveryAddress"
                    allowPromotionCode="false"
                    allowUnlockTicketTypes="false"
                    showEventBanner="true"
                    loadBootstrap="true"
                    showEventsAsList="false"
                    showEventsInCalendar="true"
                    showTicketTypesAsList="true"
                    singleTicketAsCB="false"
                    showEventsBreifDescriptions="false"
                    showEventsLocations="false"
                    showEventsStatuses="false"
                    showEventsDates="false"
                    showEventsListImages="false"
                    showEventsStartTimes="false"
                    showEventsDoorOpens="false">
                </div>
            </div>
        </div>
    );
};

export default TicketinoShopPlugin;
